export default "__VITE_ASSET__iKvap6iU__"